module.exports = __webpack_public_path__ + "img/CA.f8c2d112.svg";